<section class="mx-3">
    <div class="d-flex align-items-center">
        <!-- <div>
          <button mat-icon-button class="back_icon me-2"><i class="fa-solid fa-arrow-left"></i></button>
        </div> -->
        <div>
            <h4 translate class="m-0">Academic Year</h4>
        </div>
    </div>
    <div class="bg-white p-3 mt-2">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab label="Working Hours">
                <div class="">
                    <div class="text-end mt-2" *ngIf="shiftpermissions?.actions.create"><button mat-flat-button color="primary" class="add_button"
                            (click)="openShiftDialog()"><i class="fa-solid fa-plus"></i> <span translate>Add Shift</span></button></div>
                    <div><app-shift></app-shift></div>
                </div>
            </mat-tab>
            <mat-tab label="Week Off">
                <div class="">
                    <div class="text-end mt-2"><button mat-flat-button color="primary" class="add_button"
                            (click)="openweekoffDialog()"><i class="fa-solid fa-plus"></i> <span translate>Add Week Off</span></button>
                    </div>
                    <div><app-weekoff></app-weekoff> </div>
                </div>
            </mat-tab>
            <mat-tab label="Holidays">
                <div class="">
                    <div class="text-end mt-2"><button mat-flat-button color="primary" class="add_button"
                            (click)="openholidayDialog()"><i class="fa-solid fa-plus"></i> <span translate>Add Holiday</span></button>
                    </div>
                    <div><app-holidays></app-holidays></div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</section>